import { memo } from 'react';
import { useSelector } from 'react-redux';
import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import Filters from '../../models/Filters';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function ViewInZorseButton() {
  const filterOptions = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filterOptions);
  const filters = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters);
  const searchTerms = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.searchTerms);
  function buildUrl() {
    const state = filters.includeOpenTickets ? 'all' : 'closed';
    const queryParams = {};
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['chatAndPhone'] = filters.includeChatAndPhoneTickets;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['languages'] = filters.languages.join(',');
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['newerThanTimestamp'] = filters.dateRange.startDate;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['olderThanTimestamp'] = filters.dateRange.endDate;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['owners'] = filters.ticketOwners.map(email => filterOptions.ticketOwnersByEmail.get(email).id).join(',');
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['productAreas'] = filters.productAreas.join(',');
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['search'] = searchTerms;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    queryParams['type'] = filters.includeChatAndPhoneTickets ? undefined : 'email';
    const query = Object.keys(queryParams)
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    .filter(key => queryParams[key])
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    .map(key => `${key}=${queryParams[key]}`).join('&');
    return `https://tools.hubteam${enviro.isQa() ? 'qa' : ''}.com/zorse/53/search/all/${state}?${query}`;
  }
  return /*#__PURE__*/_jsx(UILink, {
    "data-test-id": "view-in-zorse-button-internal",
    disabled: !searchTerms.trim() && filters.equals(new Filters()),
    external: true,
    href: buildUrl(),
    onClick: () => Track.viewInZorseOpened(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "view-in-zorse-button-title",
      message: "app.search.panel.viewInZorse"
    })
  });
}
export default /*#__PURE__*/memo(ViewInZorseButton);